var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { SketchPicker } from 'react-color';
var ColorPicker = /** @class */ (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            colorSelected: _this.props.color,
            displayColorPicker: false
        };
        _this.handleClick = function () {
            _this.setState({ displayColorPicker: !_this.state.displayColorPicker });
        };
        _this.handleClose = function () {
            _this.setState({ displayColorPicker: false });
        };
        _this.handleChange = function (color, event) {
            _this.setState({ colorSelected: color.hex });
            _this.props.onChangeColor(color.hex, _this.props.name);
        };
        _this.handleChangeComplete = function (color, event) {
            _this.setState({ colorSelected: color.hex });
            _this.props.onChangeColor(color.hex, _this.props.name);
        };
        _this.handleOnSwatchHover = function (color, event) {
            _this.setState({ colorSelected: color.hex });
            _this.props.onChangeColor(color.hex, _this.props.name);
        };
        return _this;
    }
    ColorPicker.prototype.componentDidMount = function () {
        this.setState({ colorSelected: this.props.color, displayColorPicker: false });
    };
    ColorPicker.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
        if (this.state.colorSelected !== nextProps.color || this.state.displayColorPicker !== nextState.displayColorPicker) {
            this.state.colorSelected = nextProps.color;
            return true;
        }
        return false;
    };
    ColorPicker.prototype.render = function () {
        var _a = this.state, colorSelected = _a.colorSelected, displayColorPicker = _a.displayColorPicker;
        return (React.createElement("div", null,
            React.createElement("div", { style: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                }, onClick: this.handleClick },
                React.createElement("div", { style: {
                        width: '36px',
                        height: '14px',
                        borderRadius: '2px',
                        background: colorSelected,
                    } })),
            displayColorPicker ? React.createElement("div", { style: {
                    position: 'absolute',
                    zIndex: 2,
                } },
                React.createElement("div", { style: {
                        position: 'fixed',
                        top: '0px',
                        right: '0px',
                        bottom: '0px',
                        left: '0px',
                    }, onClick: this.handleClose }),
                React.createElement(SketchPicker, { color: colorSelected, onChange: this.handleChange })) : null));
    };
    return ColorPicker;
}(Component));
export default ColorPicker;



//////////////////
// WEBPACK FOOTER
// ./src/components/ColorPicker.tsx
// module id = 1322
// module chunks = 0